class FaqAccordionItem extends HTMLElement {
  constructor() {
    super()

    this.trigger = this.querySelector('.faq-accordion-item__trigger');
    this.content = this.querySelector('.faq-accordion-item__content-container');
  }

  connectedCallback() {
    this.trigger?.addEventListener('click', this.toggleAccordion.bind(this))
  }

  toggleAccordion()  {
    const isOpened = this.getAttribute('opened');

    if (isOpened) {
      this.content.style.maxHeight = 0;
      this.removeAttribute('opened');
    } else {
      this.content.style.maxHeight = this.content?.scrollHeight + 'px';
      this.setAttribute('opened', true);
    }
  }
}

if (!customElements.get('faq-accordion-item')) {
  customElements.define('faq-accordion-item', FaqAccordionItem)
}